import { cn } from 'ui'

export const PageCaption = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={cn(
        'text-muted-foreground text-xs mt-2 text-left flex-row w-full flex justify-between',
        className
      )}
    >
      {children}
    </div>
  )
}

export const PageCaptionAttribute = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return <span>{children}</span>
}
